import appConfig from '@src/app.config.json'
import Axios from 'axios'

export default Axios.create({
  baseURL: appConfig.endpoint,
  headers: {
    Authorization: appConfig.default_token,
    'Access-Control-Allow-Origin': '*',
  },
})
